// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MuiSelect-iconOpen {\n\n    transform: rotate(90deg) !important;\n    background-color: \"red\"\n\n}\n\n.MuiAutocomplete-option {\n\n    display: block !important;\n    overflow-wrap: break-word !important;\n\n}", ""]);
// Exports
module.exports = exports;
